export default {
  methods: {
    axiosMethod({ methodType = 'get', url, params, onSuccess, onError, onExtraParam, config = null}) {
      this.$api[methodType](url, params, config)
        .then((response) => onSuccess && onSuccess(response.data, onExtraParam) )
        .catch((error) => onError && onError(error, onExtraParam) )
    },
  },
}